import { createTheme, Theme } from '@mui/material/styles';
import {
  BrandPaletteKeys,
  BrandPaletteKeysEnum,
  brandPalettes,
  BREAKPOINTS,
} from '@src/themes';
import { getTheme } from '@theme'; // Your existing theme enhancer

export const createBrandTheme = (brandKey: BrandPaletteKeys): Theme => {
  let brandPalette;
  // We want cobrands that aren't ready for prod to fall back to Max's theme.
  const productionReadyBrands = [
    BrandPaletteKeysEnum.MaxMyInterest as string,
    BrandPaletteKeysEnum.FieldPointPrivate as string,
  ];

  // Check that we have a matching theme
  if (brandPalettes[brandKey]) {
    brandPalette = brandPalettes[brandKey];
    if (
      // Only let production-ready themes show
      // Revert to Max's theme if not production-ready
      import.meta.env.MODE === 'production' &&
      !productionReadyBrands.includes(brandKey)
    ) {
      brandPalette = brandPalettes[BrandPaletteKeysEnum.MaxMyInterest];
    }
  }

  if (!brandPalette) {
    console.warn(
      `Brand palette for "${brandKey}" not found. Falling back to "MaxMyInterest".`,
    );
    // Default to Max's theme
    brandPalette = brandPalettes[BrandPaletteKeysEnum.MaxMyInterest];
    const baseTheme = createTheme({
      breakpoints: BREAKPOINTS,
      palette: brandPalette,
    });

    return getTheme(baseTheme);
  }

  const baseTheme = createTheme({
    breakpoints: BREAKPOINTS,
    palette: brandPalette,
  });

  return getTheme(baseTheme);
};
